export default __webpack_public_path__ + "static/media/inactiveMic.dc11526e.png";